import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { 
  Users, Video, MessageCircle, Heart, 
  Play, Upload, TrendingUp, ArrowRight 
} from 'lucide-react';

const DigiCommunityLanding = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: <Video className="w-8 h-8" />,
      title: "Community Videos",
      description: "Share short videos up to 90 seconds. Social-style feed with scroll-based playback"
    },
    {
      icon: <MessageCircle className="w-8 h-8" />,
      title: "Smart Post Matching",
      description: "Get notified about posts relevant to your business. AI matches keywords to your category"
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Professional Network",
      description: "Connect with like-minded professionals in your industry and location"
    },
    {
      icon: <Heart className="w-8 h-8" />,
      title: "Like & Engage",
      description: "Like videos, track views, and build your audience. Real-time engagement analytics"
    },
    {
      icon: <Upload className="w-8 h-8" />,
      title: "Easy Video Uploads",
      description: "Upload videos from your device. Automatic compression and Cloudinary hosting"
    },
    {
      icon: <Play className="w-8 h-8" />,
      title: "Smooth Playback",
      description: "Auto-play videos as you scroll. Only one video plays at a time with sound"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-slate-50">
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Digi<span className="text-orange-600">Community</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Build Your Professional Network & Engage with Your Business Community
          </p>
          <div className="flex gap-4 justify-center flex-wrap">
            <Button
              onClick={() => navigate('/auth')}
              className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-6 text-lg rounded-full"
            >
              Join Community <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              onClick={() => navigate('/community')}
              variant="outline"
              className="px-8 py-6 text-lg rounded-full border-2 border-orange-600 text-orange-600 hover:bg-orange-50"
            >
              Explore Posts
            </Button>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-100"
            >
              <div className="text-orange-600 mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-orange-600 to-orange-700 rounded-3xl p-12 text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Join Your Professional Community
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Connect, engage, and grow with thousands of professionals
          </p>
          <Button
            onClick={() => navigate('/auth')}
            className="bg-white text-orange-600 hover:bg-gray-100 px-8 py-6 text-lg rounded-full font-semibold"
          >
            Get Started Free
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DigiCommunityLanding;